var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "t-toc-item"
  }, [_c('div', {
    staticClass: "t-toc-entry",
    on: {
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 61) { return null; }
        $event.preventDefault();
        return _vm.toggle(true);
      }, function ($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 173) { return null; }
        $event.preventDefault();
        return _vm.toggle(false);
      }]
    }
  }, [_c('AppLink', {
    staticClass: "t-toc-link",
    attrs: {
      "pageNum": _vm.entry['page-number'],
      "tabindex": "0"
    }
  }, [_c('span', {
    staticClass: "t-toc-text",
    domProps: {
      "innerHTML": _vm._s(_vm.titleHtml)
    }
  }), _vm._v(" … "), _c('span', {
    staticClass: "t-toc-page"
  }, [_vm._v(_vm._s(_vm.entry['logical-page']))])]), _c('button', _vm._b({
    directives: [{
      name: "visible",
      rawName: "v-visible",
      value: _vm.hasChildren,
      expression: "hasChildren"
    }],
    staticClass: "t-toc-toggle",
    on: {
      "click": function click($event) {
        return _vm.toggle();
      }
    }
  }, 'button', _vm.hasChildren ? {
    'aria-haspopup': 'tree',
    'aria-controls': _vm.$id('subtree'),
    'aria-expanded': "".concat(!!_vm.open),
    'aria-label': "Expand subtree for section: ".concat(_vm.entry.title),
    tabindex: '0'
  } : {
    'aria-hidden': 'true',
    disabled: true,
    tabindex: '-1'
  }, false), [_vm._v(" " + _vm._s(_vm.open ? '▼' : '▶') + " ")])], 1), _vm.hasChildren ? _c('Toc', {
    attrs: {
      "id": _vm.$id('subtree'),
      "level": _vm.level + 1,
      "model": _vm.entry.children,
      "open": _vm.open
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }